import { render, staticRenderFns } from "./ColorDivider.vue?vue&type=template&id=0237e38d&scoped=true"
import script from "./ColorDivider.vue?vue&type=script&lang=js"
export * from "./ColorDivider.vue?vue&type=script&lang=js"
import style0 from "./ColorDivider.vue?vue&type=style&index=0&id=0237e38d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237e38d",
  null
  
)

export default component.exports